import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { breakpoints } from '../ModalUpsell.styles';

const ImproveScore = styled.svg`
  margin: ${rem(24)} auto ${rem(-2)};
  display: inherit;
  height: auto;
  @media only screen and (min-width: ${breakpoints.mobile}) {
    max-width: ${rem(128)};
    margin-top: ${rem(8)};
  }
`;

const CEImproveScore = () => (
  <ImproveScore xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 192 90">
    <title>Improve your credit score</title>
    <g id="illustration">
      <g id="Group 3167">
        <g id="Group 28 Copy 2">
          <g id="Group 27">
            <g id="Group 3164">
              <rect
                id="Rectangle"
                width="22.2091"
                height="46.0714"
                rx="4"
                transform="matrix(-1.5 0 0 1.5 152.273 20.2009)"
                fill="#E8EDF4"
              />
              <path
                id="Rectangle_2"
                d="M152.273 26.2009C152.273 22.8872 149.587 20.2009 146.273 20.2009H124.96C121.646 20.2009 118.96 22.8872 118.96 26.2009V29.7696H152.273V26.2009Z"
                fill="#8CC33F"
              />
            </g>
            <g id="Group 3163">
              <path
                id="Rectangle Copy"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M112.657 42.1479C112.657 38.8342 109.97 36.1479 106.657 36.1479H85.343C82.0293 36.1479 79.343 38.8342 79.343 42.1479V83.3073C79.343 86.621 82.0293 89.3073 85.343 89.3073H106.657C109.97 89.3073 112.657 86.621 112.657 83.3073V42.1479Z"
                fill="#E8EDF4"
              />
              <path
                id="Rectangle_3"
                d="M112.657 42.1479C112.657 38.8342 109.97 36.1479 106.657 36.1479H85.343C82.0293 36.1479 79.343 38.8342 79.343 42.1479V45.7166H112.657V42.1479Z"
                fill="#FBDD00"
              />
            </g>
            <g id="Group 3165">
              <rect
                id="Rectangle_4"
                width="22.206"
                height="59.5385"
                rx="4"
                transform="matrix(-1.5 0 0 1.5 191.889 0)"
                fill="#E8EDF4"
              />
              <path
                id="Rectangle_5"
                d="M191.889 6C191.889 2.68629 189.203 0 185.889 0H164.576C161.262 0 158.576 2.68629 158.576 6V9.56868H191.889V6Z"
                fill="#049D4A"
              />
            </g>
            <g id="Group 3162">
              <path
                id="Rectangle Copy 2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M73.0408 54.9064C73.0408 51.5927 70.3545 48.9064 67.0408 48.9064H45.727C42.4133 48.9064 39.7271 51.5927 39.7271 54.9064V83.3075C39.7271 86.6212 42.4133 89.3075 45.7271 89.3075H67.0408C70.3545 89.3075 73.0408 86.6212 73.0408 83.3075V54.9064Z"
                fill="#E8EDF4"
              />
              <path
                id="Rectangle_6"
                d="M73.0408 54.9064C73.0408 51.5927 70.3545 48.9064 67.0408 48.9064H45.727C42.4133 48.9064 39.7271 51.5927 39.7271 54.9064V58.4751H73.0408V54.9064Z"
                fill="#F79836"
              />
            </g>
            <g id="Group 3161">
              <path
                id="Rectangle Copy 3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.4241 65.5382C33.4241 62.2245 30.7378 59.5382 27.4241 59.5382H6.11035C2.79664 59.5382 0.110351 62.2245 0.110351 65.5382V83.3074C0.110351 86.6211 2.79664 89.3074 6.11035 89.3074H27.4241C30.7378 89.3074 33.4241 86.6211 33.4241 83.3074V65.5382Z"
                fill="#E8EDF4"
              />
              <path
                id="Rectangle_7"
                d="M33.4241 65.5382C33.4241 62.2245 30.7378 59.5382 27.4241 59.5382H6.11035C2.79664 59.5382 0.110352 62.2245 0.110352 65.5382V69.1069H33.4241V65.5382Z"
                fill="#BE2228"
              />
            </g>
          </g>
        </g>
        <g id="Group 3166">
          <path
            id="Fill 2"
            d="M145.353 41.9779L149.877 45.5454L166.677 58.7926L170.175 61.5508C170.633 61.9123 171.307 61.5451 171.22 60.9809L168.122 40.736L145.749 40.8686C145.144 40.8723 144.882 41.6064 145.353 41.9779Z"
            fill="#E21C77"
          />
          <path
            id="Vector 6"
            d="M70.9983 75.7172C124.869 74.4414 133.488 67.2117 150.727 45.4164L165.272 57.1114C139.832 83.752 95.5214 80.5883 70.9984 77.0811C69.7954 76.9091 69.921 75.7172 70.9983 75.7172Z"
            fill="#E21C77"
          />
        </g>
      </g>
    </g>
  </ImproveScore>
);

export default CEImproveScore;
